import { render, staticRenderFns } from "./SetPosition.vue?vue&type=template&id=5925ff1d&"
import script from "./SetPosition.vue?vue&type=script&lang=js&"
export * from "./SetPosition.vue?vue&type=script&lang=js&"
import style0 from "./SetPosition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports